import { Link, NavLink } from "react-router-dom";
import { Dropdown } from "antd";
import { FaRegHandshake } from "react-icons/fa";
import { ROUTES } from "../../constants/_routes";
import greenMatterFinalLogo from "../../assets/images/logo.png";

import HomeIcon from "./Icons/HomeIcon";
import AboutIcon from "./Icons/AboutIcon";
import OrdersIcon from "./Icons/OrdersIcon";
import BalanceIcon from "./Icons/BalanceIcon";
import BuyerIcon from "./Icons/BuyerIcon";
import ReceivedMoneyIcon from "./Icons/ReceivedMoneyIcon";
import LuckyHourIcon from "./Icons/LuckyHourIcon";
import MerchantIcon from "./Icons/MerchantIcon";
import RentIcon from "./Icons/RentIcon";
import ProfileIcon from "./Icons/ProfileIcon";
import ContactUsIcon from "./Icons/ContactUsIcon";
import TermsIcon from "./Icons/TermsIcon";
import SignOutIcon from "./Icons/SignOutIcon";
import MoreIcon from "./Icons/MoreIcon";
import LanguageBtn from "../Common/LanguageBtn/LanguageBtn";

import { useNavbarLogic } from "./hooks/useNavbarLogic";
import NavModals from "./components/NavModals";
import { buildMoreDropdownItems } from "./components/NavMoreDropdown";
import { useTranslation } from "react-i18next";
import BuyAndSupplyIcon from "./Icons/BuyAndSupplyIcon";
import SupplyIcon from "./Icons/SupplyIcon";
import BuyIcon from "./Icons/BuyIcon";

function NavBar() {
  const { t } = useTranslation();

  const {
    isAuth,
    isEmirates,
    dir,
    location,
    navToggleBtn,
    showMoreBtn,
    offerCount,
    moneyCount,
    isBalanceVisible,
    isPendingOrdersVisible,
    isPendingOrders,
    isOffersVisible,
    isMoneyVisible,
    setIsMoneyVisible,
    showNotificationModal,
    showProfileDrawer,
    setShowProfileDrawer,
    isTermsModalOpen,
    setIsTermsModalOpen,
    orders,
    purchase,
    moneyCollection,
    selectedItem,
    terms,
    hoverStateOnPartners,
    setHoverStateOnPartners,
    color,
    setColor,
    handleCloseMenu,
    handleContact,
    handleToggleBalance,
    handleTogglePendingOrders,
    handleRenderParents,
    onCancel,
    onNotCancel,
    onOffersClose,
    handleShowOffers,
    handleShowReceived,
    handleOffer,
    handleReceivedConfirmation,
    handleBuyingFromStore,
  } = useNavbarLogic();

  const moreDropdownItems = buildMoreDropdownItems({
    dir,
    t,
    isEmirates,
    handleCloseMenu,
    setShowProfileDrawer,
    setIsTermsModalOpen,
    handleContact,
  });

  if (!isAuth) {
    return (
      <div className="recycle-nav" dir={dir}>
        <img
          className={`recycle-nav__logo ${dir} d-block`}
          src={greenMatterFinalLogo}
          alt="greenMatter"
        />
      </div>
    );
  }

  return (
    <div className="recycle-nav" dir={dir}>
      <nav className="navbar navbar-expand-lg">
        <div className="navbar__main-holder container-fluid px-3 px-lg-2 px-xxl-4 py-1 py-md-0 py-xxl-3">
          <Link
            to={
              !isEmirates
                ? ROUTES.GLOBAL
                : `${ROUTES.BUYANDSUPPLY}/${ROUTES.BUY}`
            }
            className="nav-link p-0 h-100"
          >
            <img
              className={`recycle-nav__logo ${dir} d-block`}
              src={greenMatterFinalLogo}
              alt="greenMatter"
            />
          </Link>

          <button
            type="button"
            className="navbar-toggler fs-3 text-white px-2 rounded-1 outline-0 border-0 shadow-none me-md-3"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
            ref={navToggleBtn}
          >
            <svg
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 448 512"
            >
              <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
            </svg>
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNavDropdown"
          >
            <ul
              className={`navbar-nav ${dir === "ltr" ? "pe-lg-3" : "ps-lg-3"}`}
            >
              {/* Home */}
              {!isEmirates && (
                <li className="nav-item">
                  <NavLink
                    to={ROUTES.GLOBAL}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <HomeIcon />
                    <span className="recycle-nav__nav-titles fsize-12">
                      {t("nav.home")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* About — mobile only */}
              {!showMoreBtn && !isEmirates && (
                <li className="nav-item">
                  <NavLink
                    to={ROUTES.ABOUT}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <AboutIcon />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.about")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* Pending Orders */}
              {!isEmirates && (
                <li className="nav-item" onClick={handleCloseMenu}>
                  <div
                    role="button"
                    onClick={() => handleTogglePendingOrders(true)}
                    className="d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <OrdersIcon />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.pendingOrders")}
                    </span>
                  </div>
                </li>
              )}

              {/* Pending Withdrawals */}
              {!isEmirates && (
                <li className="nav-item" onClick={handleCloseMenu}>
                  <div
                    role="button"
                    onClick={() => handleTogglePendingOrders(false)}
                    className="d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <OrdersIcon />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.pendingWithdrawals")}
                    </span>
                  </div>
                </li>
              )}

              {/* Balance */}
              {!isEmirates && (
                <li className="nav-item" onClick={handleCloseMenu}>
                  <div
                    role="button"
                    onClick={handleToggleBalance}
                    className="d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <BalanceIcon />
                    <span className="recycle-nav__nav-titles fsize-12">
                      {t("nav.balance")}
                    </span>
                  </div>
                </li>
              )}

              {/* Buyers */}
              {!isEmirates && (
                <li className="nav-item" onClick={handleCloseMenu}>
                  <div
                    role="button"
                    onClick={handleShowOffers}
                    className="d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <div className="position-relative d-flex">
                      {offerCount > 0 && (
                        <span className="recycle-nav__offers-count active-offer">
                          {offerCount > 99 ? "99+" : offerCount}
                        </span>
                      )}
                      <BuyerIcon />
                    </div>
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.buyers")}
                    </span>
                  </div>
                </li>
              )}

              {/* Received Money */}
              {!isEmirates && (
                <li className="nav-item" onClick={handleCloseMenu}>
                  <div
                    role="button"
                    onClick={handleShowReceived}
                    className="d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <div className="position-relative d-flex">
                      {moneyCount > 0 && (
                        <span
                          className="recycle-nav__offers-count active-offer"
                          style={{ right: "-5px" }}
                        >
                          {moneyCount > 99 ? "99+" : moneyCount}
                        </span>
                      )}
                      <ReceivedMoneyIcon />
                    </div>
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.received")}
                    </span>
                  </div>
                </li>
              )}

              {/* Partnerships */}
              {!isEmirates && (
                <li
                  className="nav-item"
                  onMouseEnter={() => setHoverStateOnPartners(true)}
                  onMouseLeave={() => setHoverStateOnPartners(false)}
                >
                  <NavLink
                    to={ROUTES.PARTNERSHIPS}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <FaRegHandshake
                      className="recycle-nav__nav-icon"
                      style={{
                        color:
                          hoverStateOnPartners ||
                          location.pathname.endsWith(ROUTES.PARTNERSHIPS)
                            ? "#13c156"
                            : "#fff",
                      }}
                    />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.partnership")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* Merchant */}
              {!isEmirates && (
                <li className="nav-item">
                  <NavLink
                    to={ROUTES.MERCHANT}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <MerchantIcon />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.merchant")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* Lucky Hours */}
              {!isEmirates && (
                <li className="nav-item">
                  <NavLink
                    to={ROUTES.LUCKYHOURS}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <LuckyHourIcon />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.luckyHours")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* Rent Warehouse */}
              {!isEmirates && (
                <li
                  className="nav-item"
                  onMouseEnter={() => setColor("green")}
                  onMouseLeave={() => {
                    if (location.pathname === ROUTES.RENT_WAREHOUSE) return;
                    setColor("#ffffff");
                  }}
                >
                  <NavLink
                    to={ROUTES.RENT_WAREHOUSE}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <RentIcon color={color} />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.rentSpace")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* Emirates: Buy and Supply */}
              {isEmirates && (
                <li className="nav-item">
                  <Dropdown
                    overlayClassName="buy-and-supply__dropdown"
                    menu={{
                      items: [
                        {
                          label: (
                            <NavLink
                              to="/buy-and-supply/buy"
                              onClick={handleCloseMenu}
                              className="nav-link buy-and-supply__dropdown__link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
                            >
                              <BuyIcon />
                              <span className="buy-and-supply__dropdown__link__title text-center fsize-12">
                                {t("buyAndSupply.buy")}
                              </span>
                            </NavLink>
                          ),
                          key: "0",
                        },
                        {
                          label: (
                            <NavLink
                              to="/buy-and-supply/supply"
                              onClick={handleCloseMenu}
                              className="nav-link buy-and-supply__dropdown__link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
                            >
                              <SupplyIcon />
                              <span className="buy-and-supply__dropdown__link__title text-center fsize-12">
                                {t("buyAndSupply.supply")}
                              </span>
                            </NavLink>
                          ),
                          key: "1",
                        },
                      ],
                    }}
                    trigger={["click"]}
                  >
                    <NavLink
                      to={ROUTES.BUYANDSUPPLY}
                      role="button"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                    >
                      <BuyAndSupplyIcon />
                      <span className="recycle-nav__nav-titles text-center fsize-12">
                        {t("nav.buyAndSupply")}
                      </span>
                    </NavLink>
                  </Dropdown>
                </li>
              )}

              {/* Emirates: About */}
              {isEmirates && (
                <li className="nav-item">
                  <NavLink
                    to={ROUTES.ABOUT}
                    role="button"
                    onClick={handleCloseMenu}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <AboutIcon />
                    <span className="recycle-nav__nav-titles fsize-12">
                      {t("nav.about")}
                    </span>
                  </NavLink>
                </li>
              )}

              {/* Emirates: Terms */}
              {isEmirates && (
                <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
                  <div
                    role="button"
                    onClick={() => setIsTermsModalOpen(true)}
                    className="nav-link p-0 text-decoration-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <TermsIcon />
                    <span className="recycle-nav__nav-titles fsize-12">
                      {t("nav.terms")}
                    </span>
                  </div>
                </li>
              )}

              {/* Mobile: inline profile, contact, terms, sign-out, language */}
              {!showMoreBtn && (
                <>
                  <li className="nav-item" onClick={handleCloseMenu}>
                    <button
                      type="button"
                      onClick={() => setShowProfileDrawer(true)}
                      className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                    >
                      <ProfileIcon />
                      <span className="recycle-nav__nav-titles text-center fsize-12">
                        {t("nav.profile")}
                      </span>
                    </button>
                  </li>
                  <li className="nav-item" onClick={handleCloseMenu}>
                    <Link
                      to={"#"}
                      onClick={handleContact}
                      className="nav-link p-0 d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                    >
                      <ContactUsIcon />
                      <span className="recycle-nav__nav-titles text-center fsize-12">
                        {t("nav.contactUs")}
                      </span>
                    </Link>
                  </li>
                  {!isEmirates && (
                    <li className="nav-item" onClick={handleCloseMenu}>
                      <button
                        type="button"
                        onClick={() => setIsTermsModalOpen(true)}
                        className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                      >
                        <TermsIcon />
                        <span className="recycle-nav__nav-titles text-center fsize-12">
                          {t("nav.terms")}
                        </span>
                      </button>
                    </li>
                  )}
                  <li className="nav-item">
                    <Link
                      to={ROUTES.LOGOUT}
                      className="nav-link p-0 d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                    >
                      <SignOutIcon />
                      <span className="recycle-nav__nav-titles text-center fsize-12">
                        {t("nav.signout")}
                      </span>
                    </Link>
                  </li>
                  <li className="nav-item" onClick={handleCloseMenu}>
                    <LanguageBtn />
                  </li>
                </>
              )}

              {/* Desktop: more dropdown */}
              {showMoreBtn && (
                <Dropdown
                  menu={{ items: moreDropdownItems }}
                  trigger={["click"]}
                  rootClassName="recycle-nav__more-dropdown"
                >
                  <button
                    type="button"
                    className="recycle-nav__more-dropdown__toggle-btn nav-item bg-transparent border-0 outline-none shadow-none d-flex flex-md-column gap-2 gap-md-1 align-items-center"
                  >
                    <MoreIcon />
                    <span className="recycle-nav__nav-titles text-center fsize-12">
                      {t("nav.more")}
                    </span>
                  </button>
                </Dropdown>
              )}
            </ul>
          </div>
        </div>
      </nav>

      <NavModals
        isTermsModalOpen={isTermsModalOpen}
        terms={terms}
        setIsTermsModalOpen={setIsTermsModalOpen}
        isBalanceVisible={isBalanceVisible}
        orders={orders}
        onCancel={onCancel}
        isPendingOrdersVisible={isPendingOrdersVisible}
        isPendingOrders={isPendingOrders}
        showNotificationModal={showNotificationModal}
        selectedItem={selectedItem}
        onNotCancel={onNotCancel}
        handleRenderParents={handleRenderParents}
        handleBuyingFromStore={handleBuyingFromStore}
        isOffersVisible={isOffersVisible}
        purchase={purchase}
        dir={dir}
        handleOffer={handleOffer}
        onOffersClose={onOffersClose}
        isMoneyVisible={isMoneyVisible}
        moneyCollection={moneyCollection}
        handleReceivedConfirmation={handleReceivedConfirmation}
        setIsMoneyVisible={setIsMoneyVisible}
        showProfileDrawer={showProfileDrawer}
        setShowProfileDrawer={setShowProfileDrawer}
      />
    </div>
  );
}

export default NavBar;
